<ng-template #content_working_hours let-offcanvas>
    <div class="{{localService.selectedLanguageCode}}"
        *ngIf="localService.languageContent && localService.languageContent.working_hours && localService.languageContent.common">
        <div class="side_popup_header">
            <span>{{header}}</span>
            <button class="button_icon" (click)="onCloseTrigger()">close</button>
        </div>
        <div class="side_popup_body" [ngStyle]="{'max-height' : localService.sideBarBodyHeight + 'px'}">
            <app-working-hours-range [workingRangeType]="workingRangeType" [selectedRange]="selectedRange"
                [isOnlyTime]="isOnlyTime" (onRangeUpdated)="onRangeUpdate($event)" [isHeaderRequired]="false"></app-working-hours-range>
        </div>
        <div class="side_popup_footer">
            <div class="row">
                <div class="col-12" style="text-align: right;">
                    <button type="button" class="btn btn-primary"
                    (click)="onAction(1)">{{localService.languageContent.common.save}}</button>
                </div>
            </div>
        </div>
    </div>
</ng-template>